import styled from 'styled-components'
import { useRouter } from 'next/router'
import { MdSearch, MdClose } from 'react-icons/md'
import useInputValue from 'hooks/use-input-value'

const SearchBarStyled = styled.form`
  .form-legend, .form-label {
    display: none;
  }
  .form-fieldset {
    border: none;
    padding-inline: 0px;
    padding-block: 0px;
    margin-inline: 0px;
    height: 40px;
    box-sizing: border-box;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #8B8D8D;
    display: flex;
    align-items: center;
    background: var(--basePrimary);
  }
  input {
    flex-grow: 1;
    margin-left: 4px;
    background: var(--basePrimary);
    color: var(--baseSecondary);
    font-family: var(--primaryFont);
    outline: none;
    border: none;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    padding: 0;
    line-height: 24px;
  }
  .form-state {
    align-self: flex-end;
    color: var(--secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      cursor: pointer;
    }
  }
  @media(min-width: 768px) {
    max-width: 320px;
    .form-fieldset {
      height: 48px;
      padding: 12px 8px;
    }
  }
`

function SearchBar() {
  const router = useRouter()
  const { value, onChange, setValue } = useInputValue('')

  const handleSubmit = () => {
    router.push({
      pathname: window.location.pathname,
      query: { ...router.query, search: value },
      shallow: true,
    })
  }

  const handleKeyPress = (e) => {
    if (e.which === 13) {
      e.preventDefault()
      handleSubmit()
    }
  }

  const removeSearch = () => {
    setValue('')
    router.push(window.location.pathname, { shallow: true })
  }

  return (
    <SearchBarStyled role="search" aria-labelledby="Buscar Proyecto">
      <fieldset className="form-fieldset">
        <legend className="form-legend">Buscar Proyecto</legend>
        <label className="form-label" htmlFor="search_project">
          Buscar proyecto
        </label>
        <MdSearch size={24} color="var(--black50)" />
        <input
          id="search_project"
          type="text"
          value={value}
          onChange={onChange}
          placeholder="Buscar proyecto"
          onKeyPress={(e) => handleKeyPress(e)}
        />
        <div className="form-state">
          {value !== '' ? (
            <MdClose color="var(--black50)" size={24} role="button" onClick={() => removeSearch()} />
          ) : null}
        </div>
      </fieldset>
    </SearchBarStyled>
  )
}

export default SearchBar
